/*
 * Copyright © 2023 Medaica, Inc
 *
 * All rights reserved.
 *
 * This code is confidential and proprietary information belonging to Medaica, Inc.
 * Unauthorized copying, distribution, or use of this code, in whole or in part,
 * is strictly prohibited, and may constitute a violation of intellectual property rights.
 *
 * If you have received this code in error, please notify the owner immediately
 * at support@medaica.com and delete this file from your system.
 */

import React, { ReactElement, useContext } from "react"
import { Alert } from "@mui/lab"
import { Button } from "@mui/material"
import ActionPanel from "@medaica/common/views/exam/virtual-exam/lobby/action-panel"
import ActionPanelTitle from "@medaica/common/views/exam/virtual-exam/lobby/action-panel-title"
import ActionPanelBody from "@medaica/common/views/exam/virtual-exam/lobby/action-panel-body"
import ActionPanelActions from "@medaica/common/views/exam/virtual-exam/lobby/action-panel-actions"
import LobbyBase from "@medaica/common/views/exam/virtual-exam/lobby"
import VirtualExamContext from "views/exam/virtual-exam/virtual-exam-context"

const ErrorView = ({ patientName }: { patientName: string }): ReactElement => {
  const { uiStore, preferencesStore, mediaDeviceStore } = useContext(VirtualExamContext)
  return (
    <LobbyBase mediaDeviceStore={mediaDeviceStore} preferencesStore={preferencesStore}>
      <ActionPanel>
        <ActionPanelTitle>Error entering the exam</ActionPanelTitle>
        <ActionPanelBody>
          <Alert severity="error">
            {/* eslint-disable-next-line max-len */}
            There was a system error entering the exam. Click <strong>Try again</strong> to try to enter the exam with{" "}
            {patientName}.
          </Alert>
        </ActionPanelBody>
        <ActionPanelActions>
          <Button
            onClick={() => {
              uiStore.navigate("exam")
            }}
            variant="contained"
          >
            Try again
          </Button>
          <Button onClick={uiStore.returnToDashboard} variant="outlined">
            Return to dashboard
          </Button>
        </ActionPanelActions>
      </ActionPanel>
    </LobbyBase>
  )
}

export default ErrorView
